import React, { memo } from 'react';
import { ModernVideoModelNode } from './ModernVideoModelNode';
import { KLING_O3_REFERENCE_CONFIG } from './videoModelConfigs';

export const KlingO3ReferenceVideoNode = memo(props => (
  <ModernVideoModelNode {...props} config={KLING_O3_REFERENCE_CONFIG} />
));
